/* eslint-disable @typescript-eslint/no-explicit-any */ import { css } from './css';
export function cssDependency(...deps) {
    return {
        isolatedDependencies: deps.map(({ key })=>key)
    };
}
export function cssPluginsFromObject(fn) {
    return (css)=>{
        const obj = fn(css);
        const properties = Object.keys(obj);
        const plugins = {};
        for(let i = 0; i < properties.length; i++){
            const property = properties[i];
            const values = obj[property];
            plugins[property] = function plugin(value) {
                return value in values ? values[value] || {} : {
                    [property]: value
                };
            };
        }
        return plugins;
    };
}
const cssReset = css.configure({
    layer: 'reset'
});
export function cssPluginResetStyles(selector, styles) {
    return cssDependency(cssReset({
        [selector]: styles
    }));
}

//# sourceMappingURL=plugin.js.map